var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrapper",style:('background: url(' +
		_vm.ContainerBg +
		') no-repeat center top / 100% 21.0625rem;')},[_c('HomeContainerGreeting'),_c('div',{staticClass:"home-content u-container"},[_c('HomeContainerUserResrvation'),_c('HomeContainerBanner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }